module.exports = __webpack_public_path__ + "static/media/small-arrow-Trans.1a640fa9.PNG";